import { Component, Input } from '@angular/core';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { Subject } from 'rxjs';
import { Icon } from "@types-custom/models/ui/icon-model";
import { CardActionEnum } from '@types-custom/models/ui/panel-manage-model';

@Component({
  selector: 'manage-actions-pmv',
  templateUrl: './actions-pmv.component.html',
  styleUrls: ['./actions-pmv.component.scss'],
})
export class ActionsPMVComponent {
  @Input() dispatcher: Subject<IGridTableCellDispatcher>;
  @Input() props: any;
  Icon = Icon

  actions = CardActionEnum;


  dispatchAction(action: CardActionEnum) {
    const toDispatch: IGridTableCellDispatcher = {
      index: 1,
      row: this.props.row,
      action: action,
    }

    this.dispatcher.next(toDispatch);
  }

}
